// prettier-ignore
import { 
    Component, ElementRef, ViewChild, Input, OnInit, Output, EventEmitter 
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

import { Chat, CommentType } from './chat';
import { Comments } from '@usimweb/core/models';
import { ApiService } from '@usimweb/core/services';

// user could manually insert a comment between some comments. Use hashes do valid msg order???
// allow to delete only last reply, or comment. Better do not allow to delete last reply (mark as deleted)
@Component({
    selector: 'usimweb-generic-chat',
    // changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './generic-chat.component.html',
    styleUrls: ['./generic-chat.component.scss'],
    standalone: false
})
export class GenericChatComponent extends Chat implements OnInit {
  @ViewChild('chatMessages') chatMessages!: ElementRef;

  @Input() index!: string;

  @Input() ids!: Object;

  @Input() dialogService!: any;

  @Output() loadVersion: EventEmitter<any> = new EventEmitter<any>();

  public selectedAnno = 0;

  constructor(apiService: ApiService, snackBar: MatSnackBar) {
    super(apiService, snackBar);
    this.scrollToBottom();
  }

  ngOnInit(): void {
    this.initProps(this.ids, this.dialogService);
    this.getComments();
    this.loadVersionListener.subscribe((data) => {
      this.loadVersion.emit(data);
    });
  }

  private scrollToBottom() {
    setTimeout(() => {
      this.chatMessages.nativeElement.scrollTop = this.chatMessages.nativeElement.scrollHeight;
    }, 1000);
  }

  public enablePicker(event: MouseEvent, commentType: CommentType, annotationindex: number) {}
  public deleteAnnotation(index: number, comment?: Comments) {}
  public selectAnnotation(event: any, index: number, comment?: Comments) {}
}
